import { render, staticRenderFns } from "./social-media-icons.vue?vue&type=template&id=5ed47bdc&scoped=true"
import script from "./social-media-icons.vue?vue&type=script&lang=js"
export * from "./social-media-icons.vue?vue&type=script&lang=js"
import style0 from "./social-media-icons.vue?vue&type=style&index=0&id=5ed47bdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed47bdc",
  null
  
)

export default component.exports